import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectOnlyLastFloorFilter } from 'shared/selectors/advancedFilters';

export const OnlyLastFloorContainer = () => {
  const { label, value } = useSelector(selectOnlyLastFloorFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setNotLastFloor', arguments: [newValue ? false : null] });
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Checkbox label={label} checked={value} onChange={handleChange} />
    </InlineFilter>
  );
};
